import { Component } from '@angular/core';

@Component({
  selector: 'app-carbonscore-modal-en',
  templateUrl: './carbonscore-modal-en.component.html',
  styleUrls: ['./carbonscore-modal-en.component.scss'],
  standalone: false,
})
export class CarbonscoreModalEnComponent {
  constructor() {}
}
